<template>
  <div>
    <h3 class="bet-placing-header">{{$t('vdog_ticket')}}</h3>

    <div v-show="showError" class="quick-response">
      {{getPaymentErrorMessage()}}
    </div>

    <!-- List of placed bets -->
    <div class="a-vg-aside--bets">
        <vdog-simple-ticket
          v-for="(stake, index) in picks"
          :key="getKey(stake, index)"
          :stake="stake"
          :isBettingEnabled="isBettingEnabled"
          :roundNo="roundNo"
          @onDelete="removeElement(stake)"/>
    </div>

    <vdog-input-block
      ref="inputBlockElement"
      :activeStake="activeStake"
      :isBettingEnabled="isBettingEnabled"
      v-model="money"
      :config="config"
      :currentMoney="money"
      :picks="picks"
      :roundNo="roundNo"
      :amount="amount"
      :errorIsShown="showError"
      @onDeleteAll="onDeleteAll()"/>
  </div>
</template>

<script>
import VDogSimpleTicket from '@/components/grayhound/ticket/VDogSimpleTicket.vue'
import VDogInputBlock from '@/components/grayhound/bet-placing/VDogInputBlock.vue'
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import NumberFormat from '@/mixins/NumberFormat'

export default {
  components: {
    'vdog-simple-ticket': VDogSimpleTicket,
    'vdog-input-block': VDogInputBlock
  },
  mixins: [NumberFormat],
  props: {
    config: {
      type: Object,
      required: true
    },
    activeStake: {
      type: Object,
      required: false
    },
    isBettingEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    roundNo: {
      type: Number,
      required: true
    },
    amount: {
      type: Number
    }
  },
  data: function () {
    return {
      picks: [],
      money: 0,
      defaultMinValue: 1,
      showError: false
    }
  },
  watch: {
    money: function () {
      this.reCalculateBetValue()
    },
    picks: function () {
      this.reCalculateBetValue()
      this.setMinMoneyValue()
    }
  },
  methods: {
    getMinPayin () {
      return this.config.MinPayin || 1
    },
    getPaymentErrorMessage () {
      if (this.$refs.inputBlockElement) {
        let element = this.$refs.inputBlockElement
        let message = element.getPaymentErrorMessage()
        if (message) {
          this.showError = true
          return this.$t(element.getPaymentErrorMessage(), element.getMinMaxValue())
        }
      }
      this.showError = false
      return ''
    },
    getKey: function (stake, index) {
      return stake.ID + '-' + stake.bet + '-' + index
    },
    setMinMoneyValue: function () {
      let minTotal = this.picks.length * this.getMinPayin()
      if (this.money < minTotal) {
        this.money = minTotal || 1
      }
    },
    addStake: function () {
      if (this.activeStake) {
        this.activeStake.bet = this.getMinPayin()
        this.activeStake.currency = this.config.currency
        this.picks.push(this.activeStake)
        eventBus.onChangedPicksLengthVDog(this.picks.length)
        eventBus.onSelectedStakeVDog(null)
      }
    },
    removeElement: function (element) {
      let itemIndex = this.picks.indexOf(element)
      this.picks.splice(itemIndex, 1)
      setTimeout(() => {
        this.money -= element.bet
      }, 200)
      eventBus.onChangedPicksLengthVDog(this.picks.length)
    },
    onDeleteAll: function () {
      this.picks = []
      setTimeout(() => {
        this.money = this.getMinPayin()
      }, 200)
      eventBus.onChangedPicksLengthVDog(this.picks.length)
    },
    reCalculateBetValue: function () {
      // add logic for calculate
      let minPayin = this.getMinPayin()
      let minTotal = this.picks.length * minPayin
      if (minTotal > this.money) {
        this.money = minTotal || 1
      }
      let numberOfTickets = this.picks.length
      let recalculateBet = parseFloat((this.money / numberOfTickets).toFixed(2))
      let sumBets = recalculateBet * numberOfTickets
      this.picks.forEach(element => {
        element.bet = recalculateBet
      })
      // if number of ticket is 6
      // total balance is 10
      // div 10/6 is 1.66666667
      // sum all these tickets is 10.00002 not 10.00
      if (sumBets > this.money) {
        this.picks[numberOfTickets - 1].bet = this.picks[numberOfTickets - 1].bet - (sumBets - this.money)
      } else {
        if (this.picks[numberOfTickets - 1]) {
          this.picks[numberOfTickets - 1].bet = this.picks[numberOfTickets - 1].bet + (this.money - sumBets)
        }
      }
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VDOG_CONFIRM, this.addStake)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VDOG_CONFIRM, this.addStake)
  }
}
</script>
